module.exports = __webpack_public_path__ + "media/about_employee/boston-daead5b3.png";